/**
 * SettingsRoute: `/settings` and `/settings/:section`. One page; the section
 * segment is the open tab, so a link from anywhere in the app opens the
 * part it names. A retired slug (`team`, `sso`, `billing`, `tokens`) is
 * redirected to its section with the query kept, so `yagni login`'s
 * `?code=` still arrives.
 */
import { Navigate, useLocation, useParams } from "react-router-dom";
import { LEGACY_SETTINGS_SLUGS, SettingsPage, sectionPath } from "./SettingsPage.js";

export function SettingsRoute() {
  const { section } = useParams();
  const { search } = useLocation();
  const legacy = section ? LEGACY_SETTINGS_SLUGS[section] : undefined;
  if (legacy) return <Navigate to={`${sectionPath(legacy)}${search}`} replace />;
  return <SettingsPage />;
}
